var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMammographyIcon = function SvgMammographyIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 15.3598 15.3598",
    ref: ref,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 15.3598,
    height: 15.3601
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "kevkobass-08") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page_8",
    "data-name": "Page 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page_8-2",
    "data-name": "Page 8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M6.24066,8.16058A.71973.71973,0,1,1,6.498,6.769a.23993.23993,0,0,1,.12695.333,1.82325,1.82325,0,0,0-.14014.34863c.01074.06739.03662.21094.08447.40235a.24016.24016,0,0,1-.188.29394A.74228.74228,0,0,1,6.24066,8.16058Zm-.23389-.77246a.22974.22974,0,0,0-.00634.05274.27613.27613,0,0,0,.00342.04l-.001-.00879a.223.223,0,0,1,.00195-.07422Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M7.68158,4.561H.24066a.24023.24023,0,0,1,0-.48046H7.68158a.24306.24306,0,0,0,.24023-.23926V2.88031a.24306.24306,0,0,0-.24023-.23926H.24066a.24024.24024,0,0,1,0-.48047H7.68158a.72072.72072,0,0,1,.71973.71973v.96094A.72071.72071,0,0,1,7.68158,4.561Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M7.68158,14.40082H.24066a.24024.24024,0,0,1,0-.48047H7.68158a.24325.24325,0,0,0,.24023-.24024v-.959a.24037.24037,0,0,0-.24023-.24023H.24066a.24024.24024,0,0,1,0-.48047H7.68158a.72092.72092,0,0,1,.71973.7207v.959A.72092.72092,0,0,1,7.68158,14.40082Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M10.80023,15.36176a.24.24,0,0,1-.23779-.2129s-.11865-1.041-.20508-1.99121a1.41773,1.41773,0,0,0-1.12012-1.27246A4.12359,4.12359,0,0,1,6.00238,7.41351,3.56891,3.56891,0,0,1,8.30463,5.061C10.165,4.2475,13.20111,1.4223,13.20111.24066a.23975.23975,0,1,1,.47949,0c0,1.51367-3.27978,4.42676-5.18359,5.25977C6.73236,6.27386,6.48627,7.436,6.4765,7.48578a3.59324,3.59324,0,0,0,2.86524,3.93066,1.89109,1.89109,0,0,1,1.49316,1.69825c.08643.94433.2041,1.97851.2041,1.97949a.23961.23961,0,0,1-.21094.26562Z"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMammographyIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mammography_icon.29ecaf699d37d39ef48e3fe5ca11da4e.svg";